module.exports = __webpack_public_path__ + "img/gangjiegou.03598e0d.jpg";